module.exports = __webpack_public_path__ + "img/link1.3386f844.png";